import MultiValueSelector from "../../MultiValueSelector/multiValueSelector";
import MyCheckbox from "../../MyCheckbox/myCheckbox";

export default function TrelloQuery(props) {

    const handleValueChange = (value, key) => {
        props.handleChange(key, value);
    }

    const handleDateCheck = () => {
        props.handleChange('isSortedByDate', !props.query.isSortedByDate);
    }

    return (
        <div>
            <MultiValueSelector
                options={props.options.trelloBoards}
                label="Select Boards"
                displayField="label"
                onValueChange={(value) => handleValueChange(value, 'boards')}
                initialValue={props.query ? props.query.boards : null}
            ></MultiValueSelector>
            <MyCheckbox
                label="Sort By Date Updated "
                isChecked={props.query ? props.query.isSortedByDate : false}
                onClick={handleDateCheck}
            />
        </div>
    )
}